import { LicenceIcon } from '../../../assets/icons';
import UseContext from '../../../hooks/useContext';
import UseModal from '../../modal/useModal';

const LicenceItem = ({ licence, index, tempWorkerInfos }) => {
  const { setAdminType, setAdminFileName, setAdminUserId } = UseContext();
  const { toggle } = UseModal();

  const openDocument = (type) => {
    setAdminUserId(tempWorkerInfos?.user?._id ?? '');
    setAdminFileName(licence?.licence ?? '');
    setAdminType(type);
    toggle('ad_file_view');
  };

  return (
    <div key={index} className={'flex gap-2 items-center'}>
      <div
        className={
          'w-10 h-10 min-w-10 min-h-10 flex justify-center items-center bg-gray-100 rounded'
        }
      >
        <LicenceIcon wh={20} color={'#374151'} />
      </div>
      <div className={'flex flex-col'}>
        <div
          className={'text-blue-500 cursor-pointer underline'}
          onClick={() => openDocument('licence')}
        >
          {licence.licence}
        </div>
      </div>
    </div>
  );
};

export default LicenceItem;
